import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import React, { useEffect } from 'react';

import Landing from './Pages/LandingPage'
import Dashboard from './Pages/Dashboard'
import Login from './Pages/Login';
import Register from './Pages/Register';

import history from '../history'
import FogetPassword from './Pages/FogetPassword';


function App() {

  // useEffect(() => {
  //   const handleContextMenu = (e) => {
  //     e.preventDefault();
  //   };
  //   const handleKeyDown = (e) => {
  //     // F12
  //     if (e.key === 'F12') e.preventDefault();

  //     // Ctrl+Shift+I / J / C
  //     if (e.ctrlKey && e.shiftKey && ['I', 'J', 'C'].includes(e.key.toUpperCase())) {
  //       e.preventDefault();
  //     }

  //     // Ctrl+U (view source)
  //     if (e.ctrlKey && e.key.toUpperCase() === 'U') {
  //       e.preventDefault();
  //     }
  //   };

  //   document.addEventListener('contextmenu', handleContextMenu);
  //   document.addEventListener('keydown', handleKeyDown);

  //   return () => {
  //     document.removeEventListener('contextmenu', handleContextMenu);
  //     document.removeEventListener('keydown', handleKeyDown);
  //   };
  // }, []);

  return (
    <div className="App">
      <Router history={history}>
        <Switch>
          <Route path="/" exact component={Landing} />
          <Route path="/login" component={Login} />
          <Route path="/forgot-password" component={FogetPassword} />
          <Route path="/register" component={Register} />
          <Route path="/dashboard" component={Dashboard} />
          <Redirect to="/" />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
